import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a simple modern dining chair: seat at 0.45 m, straight
// back to 0.9 m, facing +Z, base on y = 0.
const OAK = "#c8975a";
const MATTE_BLACK = "#2e2e30";

export const diningChair = defineModel({
  id: "dining-chair",
  batchId: "modern",
  name: "Dining chair",
  tags: ["modern", "interior", "furniture", "dining", "seating"],
  summary: "A simple modern dining chair with oak seat and matte-black legs.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // oak seat (top surface at 0.45)
      { geometry: new THREE.BoxGeometry(0.42, 0.05, 0.42), color: OAK, position: [0, 0.425, 0] },
      // oak back panel between the rear posts, up to 0.9
      { geometry: new THREE.BoxGeometry(0.32, 0.38, 0.04), color: OAK, position: [0, 0.71, -0.19] },
      // front legs
      { geometry: new THREE.BoxGeometry(0.04, 0.4, 0.04), color: MATTE_BLACK, position: [-0.18, 0.2, 0.17] },
      { geometry: new THREE.BoxGeometry(0.04, 0.4, 0.04), color: MATTE_BLACK, position: [0.18, 0.2, 0.17] },
      // rear posts, floor to the top of the back
      { geometry: new THREE.BoxGeometry(0.04, 0.9, 0.04), color: MATTE_BLACK, position: [-0.18, 0.45, -0.19] },
      { geometry: new THREE.BoxGeometry(0.04, 0.9, 0.04), color: MATTE_BLACK, position: [0.18, 0.45, -0.19] },
    ];
  },
  animations: [],
});
